module.exports = __webpack_public_path__ + "img/1481070185.565392ce.jpg";